/**
 * Filename for phone stats CSV download (`<a download>`).
 * When the user set a name in the modal, use that (matches POST `fileBaseName`)
 * so Chrome (exposes Content-Disposition) matches browsers that do not.
 * For Media Devoted | Created By Ciro Autiero
 */

export function parseContentDispositionFilename(
  cd: string | undefined,
): string | null {
  if (!cd?.trim()) return null;
  const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(cd);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"(.*)"$/, '$1'));
    } catch {
      return null;
    }
  }
  const quoted = /filename\s*=\s*"([^"]+)"/i.exec(cd);
  if (quoted?.[1]) return quoted[1];
  const plain = /filename\s*=\s*([^;\s]+)/i.exec(cd);
  if (plain?.[1]) return plain[1].replace(/^"|"$/g, '');
  return null;
}

export function resolvePhoneStatsCsvDownloadFilename(p: {
  contentDisposition: string | undefined;
  clientSanitizedBase: string | null | undefined;
  fallbackIsoDate: string;
}): string {
  const clientBase = p.clientSanitizedBase?.trim();
  if (clientBase) return `${clientBase}.csv`;
  const fromHeader = parseContentDispositionFilename(p.contentDisposition);
  if (fromHeader) return fromHeader;
  return `phone-stats-export-${p.fallbackIsoDate}.csv`;
}
